import fetch from '../utils/fetch'

export function syncCenterDistributorItemsList(query) {
  return fetch({
    url: '/goods/getCenterDistributorItemsList',
    method: 'get',
    params: query,
  })
}

//供应商
export function getMerchants(query) {
  return fetch({
    url: '/merchant/merchants',
    method: 'get',
    params: query,
  })
}

export function addMerchants(query) {
  return fetch({
    url: '/merchant/merchants',
    method: 'post',
    data: query
  })
}

export function editMerchants(id, query) {
  return fetch({
    url: '/merchant/merchants/' + id,
    method: 'put',
    data: query
  })
}

export function editMerchantsInfo(id, query) {
  return fetch({
    url: '/merchant/merchants/edit' + id,
    method: 'put',
    data: query
  })
}

export function delMerchants(id, query) {
  return fetch({
    url: '/merchant/merchants/' + id,
    method: 'delete',
    params: query
  })
}

// merchant_category
export function getMerchantCategory(query) {
  return fetch({
    url: '/merchant/merchant_category',
    method: 'get',
    params: query
  })
}

export function addMerchantCategory(query) {
  return fetch({
    url: '/merchant/merchant_category',
    method: 'post',
    data: query
  })
}

export function editMerchantCategory(id, query) {
  return fetch({
    url: '/merchant/merchant_category/' + id,
    method: 'put',
    data: query
  })
}

export function delMerchantCategory(id, query) {
  return fetch({
    url: '/merchant/merchant_category/' + id,
    method: 'delete',
    params: query
  })
}

export function saveMerchantCategoryMid(query) {
  return fetch({
    url: '/merchant/merchant_category_savemid',
    method: 'post',
    data: query
  })
}

//credentials
export function getMerchantCredentials(query) {
  return fetch({
    url: '/merchant/credentials',
    method: 'get',
    params: query
  })
}

export function addMerchantCredentials(query) {
  return fetch({
    url: '/merchant/credentials',
    method: 'post',
    data: query
  })
}

export function editMerchantCredentials(id, query) {
  return fetch({
    url: '/merchant/credentials/' + id,
    method: 'put',
    data: query
  })
}

export function delMerchantCredentials(id, query) {
  return fetch({
    url: '/merchant/credentials/' + id,
    method: 'delete',
    params: query
  })
}

//credential_types
export function getMerchantCredentialTypes(query) {
  return fetch({
    url: '/merchant/credential_types',
    method: 'get',
    params: query
  })
}

export function addMerchantCredentialTypes(query) {
  return fetch({
    url: '/merchant/credential_types',
    method: 'post',
    data: query
  })
}

export function editMerchantCredentialTypes(id, query) {
  return fetch({
    url: '/merchant/credential_types/' + id,
    method: 'put',
    data: query
  })
}

export function delMerchantCredentialTypes(id, query) {
  return fetch({
    url: '/merchant/credential_types/' + id,
    method: 'delete',
    params: query
  })
}

//company_account
export function getMerchantCompanyAccount(query) {
  return fetch({
    url: '/merchant/company_account',
    method: 'get',
    params: query
  })
}

export function addMerchantCompanyAccount(query) {
  return fetch({
    url: '/merchant/company_account',
    method: 'post',
    data: query
  })
}

export function editMerchantCompanyAccount(id, query) {
  return fetch({
    url: '/merchant/company_account/' + id,
    method: 'put',
    data: query
  })
}

export function delMerchantCompanyAccount(id, query) {
  return fetch({
    url: '/merchant/company_account/' + id,
    method: 'delete',
    params: query
  })
}

/*↓↓↓↓↓↓↓↓↓↓↓↓店铺分类新接口↓↓↓↓↓↓↓↓↓↓↓↓↓*/
export function getMerchantItemsCategory(query) {
  return fetch({
    url: '/merchant/items_category',
    method: 'get',
    params: query
  })
}

export function addMerchantItemsCategory(query) {
  return fetch({
    url: '/merchant/items_category',
    method: 'post',
    data: query
  })
}

export function editMerchantItemsCategory(id, query) {
  return fetch({
    url: '/merchant/items_category/' + id,
    method: 'put',
    data: query
  })
}

export function delMerchantItemsCategory(id, query) {
  return fetch({
    url: '/merchant/items_category/' + id,
    method: 'delete',
    params: query
  })
}

// 同步店铺分类数据
export function syncMerchantItemsCategory(query) {
  return fetch({
    url: '/merchant/items_category/syncOverwriteCategory',
    method: 'post',
    data: query
  })
}

export function addMerchantItemsAssociations(query) {
  return fetch({
    url: '/merchant/items_category/associations',
    method: 'post',
    data: query
  })
}

// 针对单个商品更新店铺自定义分类
export function addMerchantItemsAssociationsChange (query) {
  return fetch({
    url: '/merchant/items_category/associations/change',
    method: 'post',
    data: query
  })
}

// account_checking
export function getMerchantAccountChecking(query) {
  return fetch({
    url: '/merchant/accountchecking/list',
    method: 'get',
    params: query
  })
}

export function getMerchantAccountCheckingExport(query) {
  return fetch({
    url: '/merchant/accountchecking/export',
    method: 'get',
    params: query
  })
}

export function getMerchantBillingDetailsExport(query) {
  return fetch({
    url: '/merchant/billingdetails/export',
    method: 'get',
    params: query
  })
}

export function getMerchantBillingDetailsList(query) {
  return fetch({
    url: '/merchant/billingdetails/list',
    method: 'get',
    params: query
  })
}

//商户签约流程
export function sendcode(query) {
  return fetch({
    url: '/merchant/merchants/sendcode',
    method: 'post',
    data: query
  })
}

export function bindPhone(query) {
  return fetch({
    url: '/merchant/merchants/bindphone',
    method: 'post',
    data: query
  })
}

export function unbindPhone(query) {
  return fetch({
    url: '/merchant/merchants/unbindphone',
    method: 'post',
    data: query
  })
}

export function signContract(query) {
  return fetch({
    url: '/merchant/merchants/signcontract',
    method: 'post',
    data: query
  })
}

//idcardCollect
export function idcardCollect(query) {
  return fetch({
    url: '/merchant/merchants/idcardcollect',
    method: 'post',
    data: query
  })
}

//setCompanyInfo
export function setCompanyInfo(query) {
  return fetch({
    url: '/merchant/merchants/setcompanyinfo',
    method: 'post',
    data: query,
  })
}

//注册
export function register(query) {
  return fetch({
    url: '/merchant/merchants/register',
    method: 'post',
    data: query,
  })
}

//实名认证
export function setRealName(query) {
  return fetch({
    url: '/merchant/merchants/setrealname',
    method: 'post',
    data: query,
  })
}

//请求绑定银行卡
export function applyBindBankCard(query) {
  return fetch({
    url: '/merchant/merchants/applybindbankcard',
    method: 'post',
    data: query,
  })
}

//确认绑定银行卡
export function bindBankCard(query) {
  return fetch({
    url: '/merchant/merchants/bindbankcard',
    method: 'post',
    data: query,
  })
}

//确认解绑银行卡
export function unBindBankCard(query) {
  return fetch({
    url: '/merchant/merchants/unbindbankcard',
    method: 'post',
    data: query,
  })
}

//下载对账文件
export function getCheckAccountFile(query) {
  return fetch({
    url: '/merchant/accountchecking/getcheckaccountfile',
    method: 'get',
    params: query,
  })
}

//余额查询
export function queryBalance(query) {
  return fetch({
    url: '/merchant/accountchecking/querybalance',
    method: 'get',
    params: query,
  })
}


//单笔托管代付
export function signalAgentPay(query) {
  return fetch({
    url: '/merchant/accountchecking/signalagentpay',
    method: 'post',
    data: query,
  })
}

//批量托管代付
export function batchAgentPay(query) {
  return fetch({
    url: '/merchant/accountchecking/batchagentpay',
    method: 'post',
    data: query,
  })
}

//
export function getPaymentList(query) {
  return fetch({
    url: '/merchant/accountchecking/getpaymentlist',
    method: 'get',
    params: query,
  })
}


export function getBillingTotalList(query) {
  return fetch({
    url: '/merchant/billingtotal/list',
    method: 'get',
    params: query,
  })
}

export function getBillingTotalExportList(query) {
  return fetch({
    url: '/merchant/billingtotal/export',
    method: 'get',
    params: query,
  })
}

// VerifyAccount

export function VerifyAccount(query) {
  return fetch({
    url: '/merchant/accountchecking/verifyaccount',
    method: 'post',
    data: query,
  })
}


export function getAccountList(query) {
  return fetch({
    url: '/merchant/checkaccountfile/list',
    method: 'post',
    data: query,
  })
}

// getaccountfile
export function setAccounFile(query) {
  return fetch({
    url: '/merchant/checkaccountfile/getaccountfile',
    method: 'get',
    params: query,
  })
}

///merchant/accountchecking/querymerchantbalance

export function getQueryMerchantBalance(query) {
  return fetch({
    url: '/merchant/accountchecking/querymerchantbalance',
    method: 'get',
    params: query,
  })
}

//
export function getCheckAccountFileExport(query) {
  return fetch({
    url: '/merchant/checkaccountfile/export',
    method: 'get',
    params: query,
  })
}


export function getBalanceList(query) {
  return fetch({
    url: '/merchant/balance/getbalancelist',
    method: 'get',
    params: query,
  })
}

export function getMerchantBalance(query) {
  return fetch({
    url: '/merchant/balance/list',
    method: 'get',
    params: query,
  })
}

///merchant/accountchecking/getqueryreservefundbalance

export function getQueryReserveFundBalance(query) {
  return fetch({
    url: '/merchant/accountchecking/getqueryreservefundbalance',
    method: 'get',
    params: query,
  })
}


export function getQueryVSPFund(query) {
  return fetch({
    url: '/merchant/accountchecking/queryvspfund',
    method: 'get',
    params: query,
  })
}

//getpayeefundsintransitdetail

export function getPayeeFundsInTransitDetail(query) {
  return fetch({
    url: '/merchant/accountchecking/getpayeefundsintransitdetail',
    method: 'get',
    params: query,
  })
}

export function getBillingDate(query) {
  return fetch({
    url: '/merchant/accountchecking/updatetotal',
    method: 'get',
    params: query,
  })
}

// /merchant/billingtotal/batchagentpay

export function getBatchAgentPay(query) {
  return fetch({
    url: '/merchant/billingtotal/batchagentpay',
    method: 'post',
    data: query,
  })
}

//VerifyTotal

export function VerifyTotal(query) {
  return fetch({
    url: '/merchant/billingtotal/verify',
    method: 'post',
    data: query,
  })
}


//提现申请
export function toApply(query) {
  return fetch({
    url: '/merchant/withdrawApply/apply',
    method: 'post',
    data: query,
  })
}

//确认支付后台+验证码
export function paybybacksms(query) {
  return fetch({
    url: '/merchant/accountchecking/paybybacksms',
    method: 'post',
    data: query,
  })
}

//
export function getChooseAll(query) {
  return fetch({
    url: '/merchant/billingtotal/chooseall',
    method: 'get',
    params: query,
  })
}


export function checkAccount(query) {
  return fetch({
    url: "/merchant/accountchecking/checkAccount",
    method: 'get',
    params: query,
  })

}


export function getBalanceExport(query) {
  return fetch({
    url: '/merchant/balance/export',
    method: 'get',
    params: query,
  })
}


export function getTransferAccountExport(query) {
  return fetch({
    url: '/merchant/transferaccount/export',
    method: 'get',
    params: query,
  })
}

export function getTransferAccountList(query) {
  return fetch({
    url: '/merchant/transferaccount/list',
    method: 'get',
    params: query,
  })
}

export function getPlatformFeeList(query) {
  return fetch({
    url: '/merchant/accountchecking/getPlatformFeeList',
    method: 'get',
    params: query,
  })
}


export function signContractQuery(query) {
  return fetch({
    url: '/merchant/merchants/signContractQuery',
    method: 'get',
    params: query,
  })
}



export function getMerchantFreight(query) {
  return fetch({
    url: '/merchant/freight',
    method: 'get',
    params: query,
  })
}

export function delMerchantFreight(id) {
  return fetch({
    url: '/merchant/freight/'+id,
    method: 'delete',
  })
}

export function addMerchantFreight(query) {
  return fetch({
    url: '/merchant/freight',
    method: 'post',
    data: query
  })
}

export function editMerchantFreight(id,query) {
  return fetch({
    url: '/merchant/freight/'+id,
    method: 'put',
    data: query
  })
}


export function getMerchantTransfer(query) {
  return fetch({
    url: '/merchant/merchanttransfer',
    method: 'get',
    params: query,
  })
}

export function getMerchantTransferExport(query) {
  return fetch({
    url: '/merchant/merchanttransfer/export',
    method: 'get',
    params: query,
  })
}



// WEBPACK FOOTER //
// ./src/api/merchant.js